module.exports = __webpack_public_path__ + "static/media/cryptocurrency.39632b8c.png";